import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@fly/core';
import { PlatformService } from '@fly/platform-service';
import { COOKIE_NAMES, getCookie } from '@fly/shared';
import { useUser } from '@fly/shared-hooks';
import { FlySubMenu } from '@fly/shared-ui';

import { SubMenuList } from './SubMenuList';
import { useAccountMenuItems } from './useAccountMenuItems';

type SubMenuProps = {
  onNavClick?: () => void;
};

function AccountSubMenu({
  onNavClick,
  ref,
}: SubMenuProps & { ref?: React.Ref<HTMLDivElement> }) {
  const { t } = useTranslation();

  const menuItems = useAccountMenuItems();

  const { firstLetterUserName, username } = useUser();
  const logoutHandler = async () => {
    const platformService = PlatformService.getInstance();
    platformService.logout();
  };

  return (
    <div
      className='absolute top-[60px] right-[9px] w-full max-w-[340px]'
      data-testid='account-submenu-wrapper'
      ref={ref}
    >
      <FlySubMenu
        data-testid='account-submenu'
        className='w-full'
        title={
          <div className='flex flex-col'>
            <Text
              size='3'
              weight='bold'
              className='truncate'
              data-testid='account-submenu-user-email'
            >
              {username}
            </Text>
            <Text className='truncate' size='1'>
              {getCookie(COOKIE_NAMES.TEAM_NAME)}
            </Text>
          </div>
        }
        avatar={firstLetterUserName}
        footer={
          <Button
            className='w-full justify-start'
            type='button'
            variant='ghost'
            highContrast
            onClick={logoutHandler}
          >
            {t('app.dashboard.header.user_menu.sign_out', {
              defaultValue: 'Sign Out',
            })}
          </Button>
        }
      >
        <SubMenuList items={menuItems} onNavClick={onNavClick} />
      </FlySubMenu>
    </div>
  );
}

export { AccountSubMenu };
